import React from "react";
import PropTypes from "prop-types";
import { prismicImage } from "src/common/utils/prismic-image";
import { localiseUrlII } from "src/common/utils/format-localised-url";
import { useCountry } from "src/client/js/view/hooks";
import Button from "wonderbly-components/lib/Button";

import "./Product.scss";

const Product = ({ product, ctaHref, ctaText }) => {
  const country = useCountry();

  return (
    <article className="Bundle__Product">
      <img
        className="Bundle__Product__image"
        src={prismicImage(product.image)}
        alt={product.image.alt}
      />
      <div>
        <h3 className="Bundle__Product__title">{product.title}</h3>
        <p className="Bundle__Product__description">{product.description}</p>
        <Button href={localiseUrlII(country, ctaHref)} variant="secondary">
          {ctaText}
        </Button>
      </div>
    </article>
  );
};

Product.propTypes = {
  ctaHref: PropTypes.string,
  ctaText: PropTypes.string,
  product: PropTypes.shape({
    description: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.object,
  }),
};

export default Product;

// import React from 'react';
// import PropTypes from 'prop-types';
// import { prismicImage } from 'src/common/utils/prismic-image';
// import Button from 'wonderbly-components/lib/Button';
// import { localiseUrlII } from 'src/common/utils/format-localised-url';
// import useCountry from 'src/client/js/view/hooks/use-country';

// import './Product.scss';

// const Product = ({ product, ctaHref, ctaText }) => {
//   const country = useCountry();

//   return (
//     <article className="Bundle__Product">
//       <img
//         className="Bundle__Product__image"
//         src={prismicImage(product.image)}
//         alt={product.image.alt}
//       />
//       <div>
//         <h3 className="Bundle__Product__title">
//           {product.title}
//         </h3>
//         <p className="Bundle__Product__description">
//           {product.description}
//         </p>
//         <Button
//           href={localiseUrlII(country, ctaHref)}
//           outlined>
//           {ctaText}
//         </Button>
//       </div>
//     </article>
//   );
// };

// Product.propTypes = {
//   ctaHref: PropTypes.string,
//   ctaText: PropTypes.string,
//   product: PropTypes.shape({
//     description: PropTypes.string,
//     title: PropTypes.string,
//     image: PropTypes.object,
//   }),
// };

// export default Product;
